import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import closeIcon from "../../../assets/icons/closeIcon.svg";
import { CampaignFilterOptionsProps } from "./campaign-filter-props";
import "./campaign-filter.scss";
import dayjs, { Dayjs } from "dayjs";
import ExpectedRevenueFilter from "./campaign-filter-options/annual-revenue-filter";
import CreatedTimeFilter from "./campaign-filter-options/created-time-filter";
import CreatedByFilter from "./campaign-filter-options/created-by-filter";
import LeadOwnerFilter from "./campaign-filter-options/lead-owner-filter";
import CampaignNameFilter from "./campaign-filter-options/campiagn-name-filter";
import LeadStatusFilter from "./campaign-filter-options/lead-status-filter";
import TypeFilter from "./campaign-filter-options/type-filter";
import ExpectedResponseFilter from "./campaign-filter-options/response-filter";

const CampaignFilterOptions: React.FC<CampaignFilterOptionsProps> = (
  props: any
) => {
  const {
    setSelectedLeadsFilters,
    setIsOpenFilter,
    isOpenFilter,
    selectedLeadsFilterOptions,
    setSelectedLeadsFilterOptions,
    onApplyFilters,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    isAssign = true,
    activeFilters,
  } = props;
  const [annualRevenueRange, setAnnualRevenueRange] = useState({
    min: "",
    max: "",
  });
  const [actualCostRange, setActualCostRange] = useState({
    min: "",
    max: "",
  });
  const [budgetedCostRange, setBudgetedCostRange] = useState({
    min: "",
    max: "",
  });
  const [minValueError, setMinValueError] = useState("");
  const [maxValueError, setMaxValueError] = useState("");
  const [actualMinError, setActualMinError] = useState("");
  const [actualMaxError, setActualMaxError] = useState("");
  const [budgetedMinError, setBudgetedMinError] = useState("");
  const [budgetedMaxError, setBudgetedMaxError] = useState("");
  const [expectedResponse, setExpectedResponse] = useState("");
  const [expectedResponseError, setExpectedResponseError] = useState("");
  const [type, setType] = useState<string[]>([]);
  const [typeError, setTypeError] = useState("");
  const [leadStatusError, setLeadStatusError] = useState("");
  const [createdTime, setCreatedTime] = useState<string>("");
  const [createdTimeError, setCreatedTimeError] = useState("");
  const [createdTimeStart, setCreatedTimeStart] = useState<Dayjs | null>(null);
  const [createdTimeEnd, setCreatedTimeEnd] = useState<Dayjs | null>(null);
  const [createdTimeStartError, setCreatedTimeStartError] = useState("");
  const [createdTimeEndError, setCreatedTimeEndError] = useState("");
  const [createdByUserIds, setCreatedByUserIds] = useState<number[]>([]);
  const [createdByUserIdsError, setCreatedByUserIdsError] = useState("");
  const [leadOwnerIds, setLeadOwnerIds] = useState<number[]>([]);
  const [leadOwnerIdsError, setLeadOwnerIdsError] = useState("");
  const [assignedPartnerIds, setAssignedPartnerIds] = useState<number[]>([]);
  const [status, setStatus] = useState<string[]>([]);
  const [campaignName, setCampaignName] = useState("");
  const [campaignNameError, setCampaignNameError] = useState("");
  const [startDateRange, setStartDateRange] = useState<string[]>([]);
  const [startDateRangeError, setStartDateRangeError] = useState("");
  const [startDateFrom, setStartDateFrom] = useState<Dayjs | null>(null);
  const [startDateTo, setStartDateTo] = useState<Dayjs | null>(null);
  const [startDateFromError, setStartDateFromError] = useState("");
  const [startDateToError, setStartDateToError] = useState("");
  const [endDateFrom, setEndDateFrom] = useState<Dayjs | null>(null);
  const [endDateTo, setEndDateTo] = useState<Dayjs | null>(null);
  const [endDateRangeError, setEndDateRangeError] = useState("");
  const [endDateFromError, setEndDateFromError] = useState("");
  const [endDateToError, setEndDateToError] = useState("");
  const [draftSelectedLeadsFilterOptions, setDraftSelectedLeadsFilterOptions] =
    useState<any[]>([]);
  useEffect(() => {
    if (isOpenFilter) {
      const updatedDraft = selectedLeadsFilterOptions.map((option: any) => {
        switch (option.label) {
          case "Start Date":
            return {
              ...option,
              value: !!(
                activeFilters?.startDateFrom && activeFilters?.startDateTo
              ),
            };
          case "End Date":
            return {
              ...option,
              value: !!(activeFilters?.endDateFrom && activeFilters?.endDateTo),
            };
          case "Expected Revenue":
            return {
              ...option,
              value: !!(
                activeFilters?.annualRevenueRange?.min ||
                activeFilters?.annualRevenueRange?.max
              ),
            };
          case "Created By":
            return {
              ...option,
              value: !!activeFilters?.createdByUserIds?.length,
            };
          case "Created Time":
            return {
              ...option,
              value: !!(
                activeFilters?.createdTimeStart && activeFilters?.createdTimeEnd
              ),
            };
          case "Campaign Owner":
            return {
              ...option,
              value: !!activeFilters?.leadOwner?.length,
            };
          case "Status":
            return {
              ...option,
              value: !!activeFilters?.status?.length,
            };
          case "Type":
            return {
              ...option,
              value: !!activeFilters?.type?.length,
            };
          case "Actual Cost":
            return {
              ...option,
              value: !!(
                activeFilters?.actualCostRange?.min ||
                activeFilters?.actualCostRange?.max
              ),
            };
          case "Budgeted Cost":
            return {
              ...option,
              value: !!(
                activeFilters?.budgetedCostRange?.min ||
                activeFilters?.budgetedCostRange?.max
              ),
            };
          case "Campaign Name":
            return {
              ...option,
              value: !!activeFilters?.campaignName,
            };
          case "Expected Response":
            return {
              ...option,
              value: !!activeFilters?.expectedResponse,
            };
          default:
            return option;
        }
      });
      setDraftSelectedLeadsFilterOptions(updatedDraft);
      if (activeFilters?.assignedPartnerIds?.length) {
        setAssignedPartnerIds(activeFilters.assignedPartnerIds);
      }
      if (activeFilters?.annualRevenueRange) {
        setAnnualRevenueRange(activeFilters.annualRevenueRange);
      }
      if (activeFilters?.actualCostRange) {
        setActualCostRange(activeFilters.actualCostRange);
      }
      if (activeFilters?.budgetedCostRange) {
        setBudgetedCostRange(activeFilters.budgetedCostRange);
      }

      if (activeFilters?.leadOwnerIds) {
        setLeadOwnerIds(activeFilters.leadOwnerIds);
      }

      if (activeFilters?.status?.length) {
        setStatus(activeFilters.status);
      }

      if (activeFilters?.campaignName) {
        setCampaignName(activeFilters.campaignName);
      }

      if (activeFilters?.expectedResponse) {
        setExpectedResponse(activeFilters.expectedResponse);
      }
      if (activeFilters?.type) {
        setType(activeFilters.type);
      }
      if (activeFilters?.createdByUserIds?.length) {
        setCreatedByUserIds(activeFilters.createdByUserIds);
      }
      if (activeFilters?.startDateFrom && activeFilters?.startDateTo) {
        setStartDateRange(["Custom"]);
        setStartDateFrom(dayjs(activeFilters.startDateFrom));
        setStartDateTo(dayjs(activeFilters.startDateTo));
      }
      if (activeFilters?.endDateFrom && activeFilters?.endDateTo) {
        setStartDateRange(["Custom"]);
        setEndDateFrom(dayjs(activeFilters.endDateFrom));
        setEndDateTo(dayjs(activeFilters.endDateTo));
      }

      if (activeFilters?.createdTimeStart && activeFilters?.createdTimeEnd) {
        const start = dayjs(activeFilters.createdTimeStart);
        const end = dayjs(activeFilters.createdTimeEnd);

        const match = (a: dayjs.Dayjs, b: dayjs.Dayjs) => a.isSame(b, "second");

        if (
          match(start, dayjs().startOf("day")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedTime("Today");
        } else if (
          match(start, dayjs().subtract(1, "day").startOf("day")) &&
          match(end, dayjs().subtract(1, "day").endOf("day"))
        ) {
          setCreatedTime("Yesterday");
        } else if (
          match(start, dayjs().startOf("week")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedTime("This Week");
        } else if (
          match(start, dayjs().startOf("month")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedTime("This Month");
        } else if (
          match(
            start,
            dayjs()
              .subtract(1, "week")
              .startOf("week")
              .hour(0)
              .minute(0)
              .second(0)
          ) &&
          match(
            end,
            dayjs()
              .subtract(1, "week")
              .endOf("week")
              .hour(23)
              .minute(59)
              .second(0)
          )
        ) {
          setCreatedTime("Last Week");
        } else if (
          match(
            start,
            dayjs()
              .subtract(1, "month")
              .startOf("month")
              .hour(0)
              .minute(0)
              .second(0)
          ) &&
          match(
            end,
            dayjs()
              .subtract(1, "month")
              .endOf("month")
              .hour(23)
              .minute(59)
              .second(0)
          )
        ) {
          setCreatedTime("Last Month");
        } else {
          setCreatedTime("Custom");
          setCreatedTimeStart(start);
          setCreatedTimeEnd(end);
        }
      }
    }
  }, [isOpenFilter]);
  const isAnyFilterSelected = draftSelectedLeadsFilterOptions.some(
    (option: any) => option.value
  );
  const handleChange = (e: any) => {
    // const tempSelectedLeadsFilterOptions = selectedLeadsFilterOptions?.map(
    //   (data: any) => {
    //     return data?.labels === e.target.id
    //       ? { ...data, value: !data?.value }
    //       : data;
    //   },
    // );
    const updatedDraft = draftSelectedLeadsFilterOptions.map((data: any) =>
      data?.labels === e.target.id ? { ...data, value: !data?.value } : data
    );
    const isStartDateChecked = e.target.id === "Start Date" && e.target.checked;
    const isStartDateUnchecked =
      e.target.id === "Start Date" && !e.target.checked;

    if (isStartDateChecked) {
      setStartDateRange(["Custom"]);
    }

    if (isStartDateUnchecked) {
      setStartDateRange([]);
      setStartDateFrom(null);
      setStartDateTo(null);
      setStartDateRangeError("");
      setStartDateFromError("");
      setStartDateToError("");
    }
    const isEndDateChecked = e.target.id === "End Date" && e.target.checked;
    const isEndDateUnchecked = e.target.id === "End Date" && !e.target.checked;
    if (isEndDateChecked) {
      setStartDateRange(["Custom"]);
    }
    if (isEndDateUnchecked) {
      setStartDateRange([]);
      setEndDateFrom(null);
      setEndDateTo(null);
      setEndDateRangeError("");
      setEndDateFromError("");
      setEndDateToError("");
    }

    const isAnnualRevenueUnchecked =
      e.target.id === "Expected Revenue" && !e.target.checked;
    if (isAnnualRevenueUnchecked) {
      setAnnualRevenueRange({ min: "", max: "" });
      setMinValueError("");
      setMaxValueError("");
    }
    const isActualCostUnchecked =
      e.target.id === "Actual Cost" && !e.target.checked;
    if (isActualCostUnchecked) {
      setActualCostRange({ min: "", max: "" });
      setActualMinError("");
      setActualMaxError("");
    }
    const isBudgetedCostUnchecked =
      e.target.id === "Budgeted Cost" && !e.target.checked;
    if (isBudgetedCostUnchecked) {
      setBudgetedCostRange({ min: "", max: "" });
      setBudgetedMinError("");
      setBudgetedMaxError("");
    }
    const isCampaignNameUnchecked =
      e.target.id === "Campaign Name" && !e.target.checked;
    if (isCampaignNameUnchecked) {
      setCampaignName("");
      setCampaignNameError("");
    }
    const isExpectedResponseUnchecked =
      e.target.id === "Expected Response" && !e.target.checked;
    if (isExpectedResponseUnchecked) {
      setExpectedResponse("");
      setExpectedResponseError("");
    }
    const isCreatedByUnchecked =
      e.target.id === "Created By" && !e.target.checked;
    if (isCreatedByUnchecked) {
      setCreatedByUserIds([]);
      setCreatedByUserIdsError("");
    }
    const isLeadOwnerUnchecked =
      e.target.id === "Campaign Owner" && !e.target.checked;
    if (isLeadOwnerUnchecked) {
      setLeadOwnerIds([]);
      setLeadOwnerIdsError("");
    }
    const isCreatedTimeUnchecked =
      e.target.id === "Created Time" && !e.target.checked;
    if (isCreatedTimeUnchecked) {
      setCreatedTime("");
      setCreatedTimeStart(null);
      setCreatedTimeEnd(null);
      setCreatedTimeError("");
      setCreatedTimeStartError("");
      setCreatedTimeEndError("");
    }
    const isTypeUnchecked = e.target.id === "Type" && !e.target.checked;
    if (isTypeUnchecked) {
      setType([]);
      setTypeError("");
    }
    const isLeadStatusUnchecked = e.target.id === "Status" && !e.target.checked;
    if (isLeadStatusUnchecked) {
      setStatus([]);
      setLeadStatusError("");
    }
    setDraftSelectedLeadsFilterOptions(updatedDraft);
    // setSelectedLeadsFilters(
    //   tempSelectedLeadsFilterOptions?.filter((data: any) => {
    //     return data?.value;
    //   }),
    // );
  };
  const handleReset = () => {
    const resetFilters = selectedLeadsFilterOptions.map((option: any) => ({
      ...option,
      value: false,
    }));

    setSelectedLeadsFilterOptions(resetFilters);
    setDraftSelectedLeadsFilterOptions(resetFilters);

    setSelectedLeadsFilterOptions(resetFilters);
    setAnnualRevenueRange({ min: "", max: "" });
    setActualCostRange({ min: "", max: "" });
    setBudgetedCostRange({ min: "", max: "" });
    setMinValueError("");
    setMaxValueError("");
    setCampaignName("");
    setCampaignNameError("");
    setExpectedResponse("");
    setExpectedResponseError("");
    setCreatedTimeStart(null);
    setCreatedTimeEnd(null);
    setCreatedTimeStartError("");
    setCreatedTimeEndError("");
    setCreatedTime("");
    setCreatedTimeError("");
    setCreatedByUserIds([]);
    setType([]);
    setTypeError("");
    setLeadStatusError("");
    setCreatedByUserIdsError("");
    setLeadOwnerIds([]);
    setLeadOwnerIdsError("");
    setAssignedPartnerIds([]);
    setSelectedLeadsFilters([]);
    setStartDateRange([]);
    setStartDateFrom(null);
    setStartDateTo(null);
    setStartDateRangeError("");
    setStartDateFromError("");
    setStartDateToError("");
    setStartDateRangeError("");
    setEndDateFrom(null);
    setEndDateTo(null);
    setEndDateRangeError("");
    setEndDateFromError("");
    setEndDateToError("");
    setEndDateFromError("");
    setEndDateToError("");
    setEndDateRangeError("");
    props.onApplyFilters({});
    setIsOpenFilter(false);
  };
  const handleAnnualRevenueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    if (e.target instanceof HTMLInputElement) {
      const value = e.target.value;
      const updatedRange = {
        ...annualRevenueRange,
        [field]: value,
      };
      setAnnualRevenueRange(updatedRange);
      if (field === "min" && value.trim()) {
        setMinValueError("");
      }
      if (field === "max" && value.trim()) {
        setMaxValueError("");
      }
    }
  };
  const handleActualCostChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    if (e.target instanceof HTMLInputElement) {
      const value = e.target.value;
      const updatedRange = {
        ...actualCostRange,
        [field]: value,
      };
      setActualCostRange(updatedRange);
      if (field === "min" && value.trim()) {
        setActualMinError("");
      }
      if (field === "max" && value.trim()) {
        setActualMaxError("");
      }
    }
  };
  const handleBudgetedCostChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    if (e.target instanceof HTMLInputElement) {
      const value = e.target.value;
      const updatedRange = {
        ...budgetedCostRange,
        [field]: value,
      };
      setBudgetedCostRange(updatedRange);
      if (field === "min" && value.trim()) {
        setBudgetedMinError("");
      }
      if (field === "max" && value.trim()) {
        setBudgetedMaxError("");
      }
    }
  };

  const handleCampaignNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCampaignName(value);
    if (value.trim() !== "") {
      setCampaignNameError("");
    }
  };
  const handleExpectedResponseChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    setExpectedResponse(value);
    if (value.trim() !== "") {
      setExpectedResponseError("");
    }
  };
  const handleTypeChange = (value: string[]) => {
    setType(value);
    const hasValidValue = value.some((val) => val.trim() !== "");

    if (hasValidValue) {
      setTypeError("");
    }
  };
  const handleLeadStatusChange = (value: string[]) => {
    setStatus(value);
    const hasValidValue = value.some((val) => val.trim() !== "");

    if (hasValidValue) {
      setLeadStatusError("");
    }
  };
  const handleCreatedTimeChange = (value: string) => {
    setCreatedTime(value);

    if (value.length > 0) {
      setCreatedTimeError("");
    }
    if (!value.includes("Custom")) {
      setCreatedTimeStart(null);
      setCreatedTimeEnd(null);
      setCreatedTimeStartError("");
      setCreatedTimeEndError("");
    }
  };

  const handleCreatedByChange = (selectedIds: number[]) => {
    setCreatedByUserIds(selectedIds);

    if (selectedIds.length > 0) {
      setCreatedByUserIdsError("");
    }
  };
  const handleLeadOwnerChange = (selectedIds: number[]) => {
    setLeadOwnerIds(selectedIds);

    if (selectedIds.length > 0) {
      setLeadOwnerIdsError("");
    }
  };
  const handleCreatedTimeDateRange = (from: Date | null, to: Date | null) => {
    setCreatedTimeStart(from ? dayjs(from) : null);
    setCreatedTimeEnd(to ? dayjs(to) : null);

    if (from) setCreatedTimeStartError("");
    if (to) setCreatedTimeEndError("");
  };

  // const isEmailEnabled = draftSelectedLeadsFilterOptions.find(
  //   (opt: any) => opt.labels === "Email"
  // )?.value;
  const isAnnualRevenueEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Expected Revenue"
  )?.value;
  const isActualCostEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Actual Cost"
  )?.value;
  const isBudgetedCostEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Budgeted Cost"
  )?.value;
  const isCampaignNameEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Campaign Name"
  )?.value;
  const isExpectedResponseEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Expected Response"
  )?.value;
  // const isCompanyEnabled = selectedLeadsFilterOptions.find(
  //   (opt: any) => opt.labels === "Company"
  // )?.value;
  // const isIndustryEnabled = draftSelectedLeadsFilterOptions.find(
  //   (opt: any) => opt.labels === "Industry"
  // )?.value;
  const isTypeEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Type"
  )?.value;
  const isCreatedTimeEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Created Time"
  )?.value;
  const isStartDateEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Start Date"
  )?.value;
  const isEndDateEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "End Date"
  )?.value;
  const isCreatedByEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Created By"
  )?.value;
  const isLeadOwnerEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Campaign Owner"
  )?.value;
  const isLeadStatusEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Status"
  )?.value;
  // const isAssignedPartnerEnabled = draftSelectedLeadsFilterOptions.find(
  //   (opt: any) => opt.labels === "Assigned Partner"
  // )?.value;
  const renderFilterField = (optionLabel: string) => {
    switch (optionLabel) {
      case "Expected Revenue":
        return (
          <ExpectedRevenueFilter
            annualRevenueRange={annualRevenueRange}
            handleAnnualRevenueChange={handleAnnualRevenueChange}
            isExpectedRevenueEnabled={isAnnualRevenueEnabled}
            minValueError={minValueError}
            maxValueError={maxValueError}
          />
        );
      case "Actual Cost":
        return (
          <ExpectedRevenueFilter
            annualRevenueRange={actualCostRange}
            handleAnnualRevenueChange={handleActualCostChange}
            isExpectedRevenueEnabled={isActualCostEnabled}
            minValueError={actualMinError}
            maxValueError={actualMaxError}
          />
        );
      case "Budgeted Cost":
        return (
          <ExpectedRevenueFilter
            annualRevenueRange={budgetedCostRange}
            handleAnnualRevenueChange={handleBudgetedCostChange}
            isExpectedRevenueEnabled={isBudgetedCostEnabled}
            minValueError={budgetedMinError}
            maxValueError={budgetedMaxError}
          />
        );
      case "Campaign Name":
        return (
          <CampaignNameFilter
            campaignName={campaignName}
            handleCampaignNameChange={handleCampaignNameChange}
            isCampaignNameEnabled={isCampaignNameEnabled}
            campaignNameError={campaignNameError}
          />
        );
      case "Expected Response":
        return (
          <ExpectedResponseFilter
            expectedResponse={expectedResponse}
            handleExpectedResponseChange={handleExpectedResponseChange}
            isExpectedResponseEnabled={isExpectedResponseEnabled}
            expectedResponseError={expectedResponseError}
          />
        );
      case "Type":
        return (
          <TypeFilter
            value={type}
            onChange={handleTypeChange}
            isTypeEnabled={isTypeEnabled}
            typeError={typeError}
          />
        );
      case "Status":
        return (
          <LeadStatusFilter
            value={status}
            onChange={handleLeadStatusChange}
            isLeadStatusEnabled={isLeadStatusEnabled}
            leadStatusError={leadStatusError}
          />
        );
      case "Created Time":
        return (
          <CreatedTimeFilter
            value={createdTime}
            onChange={handleCreatedTimeChange}
            isCreatedTimeEnabled={isCreatedTimeEnabled}
            onDateRangeChange={handleCreatedTimeDateRange}
            createdTimeError={createdTimeError}
            createdTimeStartError={createdTimeStartError}
            createdTimeEndError={createdTimeEndError}
            setCreatedTimeFromDate={setCreatedTimeStart}
            setCretedTimeToDate={setCreatedTimeEnd}
          />
        );
      case "Created By":
        return (
          <CreatedByFilter
            value={createdByUserIds}
            onChange={handleCreatedByChange}
            isCreatedByEnabled={isCreatedByEnabled}
            createdByUserIdsError={createdByUserIdsError}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        );
      case "Campaign Owner":
        return (
          <LeadOwnerFilter
            value={leadOwnerIds}
            onChange={handleLeadOwnerChange}
            isLeadOwnerEnabled={isLeadOwnerEnabled}
            leadOwnerIdsError={leadOwnerIdsError}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        );
      case "Start Date":
        return (
          <CreatedTimeFilter
            value={"Custom"}
            onChange={() => {}}
            isCreatedTimeEnabled={
              draftSelectedLeadsFilterOptions.find(
                (opt: any) => opt.labels === "Start Date"
              )?.value
            }
            onDateRangeChange={(from, to) => {
              setStartDateFrom(from ? dayjs(from) : null);
              setStartDateTo(to ? dayjs(to) : null);
              if (from) setStartDateFromError("");
              if (to) setStartDateToError("");
            }}
            createdTimeError={startDateRangeError}
            createdTimeStartError={startDateFromError}
            createdTimeEndError={startDateToError}
            setCreatedTimeFromDate={setStartDateFrom}
            setCretedTimeToDate={setStartDateTo}
            showDropdown={false}
            fromDate={startDateFrom}
            toDate={startDateTo}
            allowFutureDates={true}
          />
        );
      case "End Date":
        return (
          <CreatedTimeFilter
            value={"Custom"}
            onChange={() => {}}
            isCreatedTimeEnabled={
              draftSelectedLeadsFilterOptions.find(
                (opt: any) => opt.labels === "End Date"
              )?.value
            }
            onDateRangeChange={(from, to) => {
              setEndDateFrom(from ? dayjs(from) : null);
              setEndDateTo(to ? dayjs(to) : null);
              if (from) setEndDateFromError("");
              if (to) setEndDateToError("");
            }}
            createdTimeError={endDateRangeError}
            createdTimeStartError={endDateFromError}
            createdTimeEndError={endDateToError}
            setCreatedTimeFromDate={setEndDateFrom}
            setCretedTimeToDate={setEndDateTo}
            showDropdown={false}
            fromDate={endDateFrom}
            toDate={endDateTo}
            allowFutureDates={true}
          />
        );

      default:
        return null;
    }
  };
  const handleApplyFilters = () => {
    let hasError = false;
    if (isCampaignNameEnabled && !campaignName.trim()) {
      setCampaignNameError("Enter Campaign Name");
      hasError = true;
    } else {
      setCampaignNameError("");
    }
    if (isExpectedResponseEnabled && !expectedResponse.trim()) {
      setExpectedResponseError("Enter Expected Response");
      hasError = true;
    } else {
      setExpectedResponseError("");
    }
    if (
      isTypeEnabled &&
      (type.length === 0 || type.every((val) => val.trim() === ""))
    ) {
      setTypeError("Select Type");
      hasError = true;
    } else {
      setTypeError("");
    }
    if (
      isLeadStatusEnabled &&
      (status.length === 0 || status.every((val) => val.trim() === ""))
    ) {
      setLeadStatusError("Select Status");
      hasError = true;
    } else {
      setLeadStatusError("");
    }
    if (isCreatedByEnabled && createdByUserIds.length === 0) {
      setCreatedByUserIdsError("Select Created By");
      hasError = true;
    } else {
      setCreatedByUserIdsError("");
    }
    if (isLeadOwnerEnabled && leadOwnerIds.length === 0) {
      setLeadOwnerIdsError("Select Campaign Owner");
      hasError = true;
    } else {
      setLeadOwnerIdsError("");
    }
    if (isAnnualRevenueEnabled) {
      if (!annualRevenueRange.min.trim()) {
        setMinValueError("Enter Min Value");
        hasError = true;
      } else {
        setMinValueError("");
      }
      if (!annualRevenueRange.max.trim()) {
        setMaxValueError("Enter Max Value");
        hasError = true;
      } else {
        setMaxValueError("");
      }
      if (
        annualRevenueRange.min.trim() &&
        annualRevenueRange.max.trim() &&
        !isNaN(Number(annualRevenueRange.min)) &&
        !isNaN(Number(annualRevenueRange.max)) &&
        Number(annualRevenueRange.min) > Number(annualRevenueRange.max)
      ) {
        setMinValueError("Min value cannot be greater than Max value");
        setMaxValueError("Max value cannot be less than Min value");
        hasError = true;
      }
    } else {
      setMinValueError("");
      setMaxValueError("");
    }
    if (isActualCostEnabled) {
      if (!actualCostRange.min.trim()) {
        setActualMinError("Enter Min Value");
        hasError = true;
      } else {
        setActualMinError("");
      }
      if (!actualCostRange.max.trim()) {
        setActualMaxError("Enter Max Value");
        hasError = true;
      } else {
        setActualMaxError("");
      }
      if (
        actualCostRange.min.trim() &&
        actualCostRange.max.trim() &&
        !isNaN(Number(actualCostRange.min)) &&
        !isNaN(Number(actualCostRange.max)) &&
        Number(actualCostRange.min) > Number(actualCostRange.max)
      ) {
        setActualMinError("Min value cannot be greater than Max value");
        setActualMaxError("Max value cannot be less than Min value");
        hasError = true;
      }
    } else {
      setActualMinError("");
      setActualMaxError("");
    }
    if (isBudgetedCostEnabled) {
      if (!budgetedCostRange.min.trim()) {
        setBudgetedMinError("Enter Min Value");
        hasError = true;
      } else {
        setBudgetedMinError("");
      }
      if (!budgetedCostRange.max.trim()) {
        setBudgetedMaxError("Enter Max Value");
        hasError = true;
      } else {
        setBudgetedMaxError("");
      }

      if (
        budgetedCostRange.min.trim() &&
        budgetedCostRange.max.trim() &&
        !isNaN(Number(budgetedCostRange.min)) &&
        !isNaN(Number(budgetedCostRange.max)) &&
        Number(budgetedCostRange.min) > Number(budgetedCostRange.max)
      ) {
        setBudgetedMinError("Min value cannot be greater than Max value");
        setBudgetedMaxError("Max value cannot be less than Min value");
        hasError = true;
      }
    } else {
      setBudgetedMinError("");
      setBudgetedMaxError("");
    }
    if (isCreatedTimeEnabled) {
      if (createdTime.length === 0) {
        setCreatedTimeError("Select Created Time");
        hasError = true;
      } else {
        setCreatedTimeError("");
      }
      if (createdTime.includes("Custom")) {
        if (!createdTimeStart) {
          setCreatedTimeStartError("Start date is required");
          hasError = true;
        } else if (
          !dayjs(createdTimeStart).isValid() ||
          dayjs(createdTimeStart).year() < 1900
        ) {
          setCreatedTimeStartError("Invalid date");
          hasError = true;
        } else {
          setCreatedTimeStartError("");
        }

        if (!createdTimeEnd) {
          setCreatedTimeEndError("End date is required");
          hasError = true;
        } else if (
          !dayjs(createdTimeEnd).isValid() ||
          dayjs(createdTimeEnd).year() < 1900
        ) {
          setCreatedTimeEndError("Invalid date");
          hasError = true;
        } else {
          setCreatedTimeEndError("");
        }
        if (
          createdTimeStart &&
          createdTimeEnd &&
          dayjs(createdTimeStart).isValid() &&
          dayjs(createdTimeEnd).isValid() &&
          dayjs(createdTimeStart).isAfter(dayjs(createdTimeEnd))
        ) {
          setCreatedTimeStartError(
            "Start date cannot be greater than end date"
          );
          setCreatedTimeEndError("End date cannot be less than start date");
          hasError = true;
        }
      } else {
        setCreatedTimeStartError("");
        setCreatedTimeEndError("");
      }
    }
    if (isStartDateEnabled) {
      if (!startDateFrom) {
        setStartDateFromError("Start date is required");
        hasError = true;
      } else if (
        !dayjs(startDateFrom).isValid() ||
        dayjs(startDateFrom).year() < 1900
      ) {
        setStartDateFromError("Invalid date");
        hasError = true;
      } else {
        setStartDateFromError("");
      }

      if (!startDateTo) {
        setStartDateToError("End date is required");
        hasError = true;
      } else if (
        !dayjs(startDateTo).isValid() ||
        dayjs(startDateTo).year() < 1900
      ) {
        setStartDateToError("Invalid date");
        hasError = true;
      } else {
        setStartDateToError("");
      }
      if (
        startDateFrom &&
        startDateTo &&
        dayjs(startDateFrom).isAfter(dayjs(startDateTo))
      ) {
        setStartDateFromError("Start date cannot be greater than end date");
        setStartDateToError("End date cannot be less than start date");
        hasError = true;
      }
    } else {
      setStartDateRangeError("");
      setStartDateFromError("");
      setStartDateToError("");
    }
    if (isEndDateEnabled) {
      if (!endDateFrom) {
        setEndDateFromError("Start date is required");
        hasError = true;
      } else if (
        !dayjs(endDateFrom).isValid() ||
        dayjs(endDateFrom).year() < 1900
      ) {
        setEndDateFromError("Invalid date");
        hasError = true;
      } else {
        setEndDateFromError("");
      }

      if (!endDateTo) {
        setEndDateToError("End date is required");
        hasError = true;
      } else if (
        !dayjs(endDateTo).isValid() ||
        dayjs(endDateTo).year() < 1900
      ) {
        setEndDateToError("Invalid date");
        hasError = true;
      } else {
        setEndDateToError("");
      }
      if (
        endDateFrom &&
        endDateTo &&
        dayjs(endDateFrom).isAfter(dayjs(endDateTo))
      ) {
        setEndDateFromError("Start date cannot be greater than end date");
        setEndDateToError("End date cannot be less than start date");
        hasError = true;
      }
    } else {
      setEndDateRangeError("");
      setEndDateFromError("");
      setEndDateToError("");
    }

    if (hasError) {
      return;
    }
    const filtersToApply: any = {};
    if (
      isAnnualRevenueEnabled &&
      (annualRevenueRange.min.trim() || annualRevenueRange.max.trim())
    ) {
      filtersToApply.annualRevenueRange = annualRevenueRange;
    }
    if (isActualCostEnabled && (actualCostRange.min.trim() || actualCostRange.max.trim())) {
      filtersToApply.actualCostRange = actualCostRange;
    }
    if (
      isBudgetedCostEnabled &&
      (budgetedCostRange.min.trim() || budgetedCostRange.max.trim())
    ) {
      filtersToApply.budgetedCostRange = budgetedCostRange;
    }
    if (isCampaignNameEnabled && campaignName.trim()) {
      filtersToApply.campaignName = campaignName;
    }
    if (isExpectedResponseEnabled && expectedResponse.trim()) {
      filtersToApply.expectedResponse = expectedResponse;
    }
    if (isTypeEnabled && type.length > 0) filtersToApply.type = type;
    if (isLeadStatusEnabled && status.length > 0) filtersToApply.status = status;
    if (isCreatedTimeEnabled && createdTimeStart && createdTimeEnd) {
      filtersToApply.createdTimeStart = createdTimeStart;
      filtersToApply.createdTimeEnd = createdTimeEnd;
    }
    if (isCreatedByEnabled && createdByUserIds.length > 0) {
      filtersToApply.createdByUserIds = createdByUserIds;
    }
    if (isLeadOwnerEnabled && leadOwnerIds.length > 0) {
      filtersToApply.leadOwnerIds = leadOwnerIds;
    }
    if (isStartDateEnabled && startDateFrom && startDateTo) {
      filtersToApply.startDateFrom = startDateFrom;
      filtersToApply.startDateTo = startDateTo;
    }
    if (isEndDateEnabled && endDateFrom && endDateTo) {
      filtersToApply.endDateFrom = endDateFrom;
      filtersToApply.endDateTo = endDateTo;
    }
    onApplyFilters(filtersToApply);
    setSelectedLeadsFilterOptions(draftSelectedLeadsFilterOptions);
    setSelectedLeadsFilters(
      draftSelectedLeadsFilterOptions.filter((data: any) => data.value)
    );
    setIsOpenFilter(false);
  };
  return (
    <div className="lead-filter-options-wrapper campaign-filter-options-wrapper">
      <div className="lead-filter-options-container campaign-filter-options-container">
        <div className="header-wrapper">
          <div className="lead-filter-options-container-header">
            <div className="lead-filter-options-container-header-text">
              Filters
            </div>
            <div className="lead-filter-options-container-header-icon">
              <img
                src={closeIcon}
                alt="Filter Icon"
                onClick={() => setIsOpenFilter(!isOpenFilter)}
              />
            </div>
          </div>
          <div className="lead-filter-options-container-subtext">
            Filter By Fields
          </div>
        </div>
        <div className="lead-filter-options-container-list campaign-filter-options-container-list">
          {draftSelectedLeadsFilterOptions.map((option: any) => (
            <div key={option.labels}>
              <label
                htmlFor={option.labels}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  checked={option?.value}
                  onChange={handleChange}
                  id={option.labels}
                />
                <ListItemText primary={option.labels} />
              </label>
              {option?.value && renderFilterField(option.labels)}
            </div>
          ))}
          {isAnyFilterSelected && (
            <div className="lead-filter-buttons">
              <button
                className="cancel-button"
                onClick={() => {
                  handleReset();
                }}
              >
                Reset
              </button>
              <button
                className="next-button-wrapper"
                type="submit"
                onClick={handleApplyFilters}
              >
                Apply
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignFilterOptions;
